module.exports = __webpack_public_path__ + "img/文字_C级赛事@2x.31b34624.png";